// Session expiration time (for localStorage)
export const SESSION_EXP_STORAGE_KEY = 'application_name_session_expiration_time';
